import { shallowEqual, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "../../store";
import React from "react";

const ProtectedRoute = ({ children }: any) => {
  const token = useSelector(
    (state: RootState) => state.auth.token,
    shallowEqual,
  );

  if (!token) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};

export default React.memo(ProtectedRoute);